import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import IdiomFill from '~/admin/components/questions/IdiomFill.jsx';
import { buildIdiomsProps } from '~/app/adapters/questionAdapters';

export default function FieldIdiomFill({
  question: q, qIndex, disabled = false, showAns = false, resetSignal, showReset = true,
}) {
  const { setFieldValue, values } = useFormikContext();

  // Memoize adapter output to avoid unnecessary re-renders and stabilize slot indices
  const {
    tokens, gridSize, slots, answers, idioms,
  } = useMemo(() => (
    buildIdiomsProps(q)
  ), [q && q._id, JSON.stringify(q && q.tokens), JSON.stringify(q && q.idioms), JSON.stringify(q && q.gridSize), JSON.stringify(q && q.answers)]);

  const handleChange = (report) => {
    if (report && Array.isArray(report.slotAnswers)) {
      // schedule Formik update asynchronously to avoid updating Formik during render of child
      Promise.resolve().then(() => {
        const texts = report.slotAnswers.map((idx) => {
          if (idx == null) return null;
          const i = parseInt(idx, 10);
          return (tokens && tokens[i]) ? tokens[i].text : null;
        });
        // find answer index by matching question id in form values to be resilient to ordering
        let targetIndex = qIndex;
        if (values && Array.isArray(values.answers)) {
          const found = values.answers.findIndex((a) => String(a && a.question) === String(q && q._id));
          if (found >= 0) targetIndex = found;
        }
        setFieldValue(`answers.${targetIndex}.answeredSeq`, texts);
      });
    }
  };

  return (
    <IdiomFill
      tokens={tokens}
      gridSize={gridSize}
      slots={slots}
      answers={answers}
      idioms={idioms}
      onChange={handleChange}
      showExpected={showAns}
      restrictEdit={disabled}
      resetSignal={resetSignal}
      showReset={showReset}
      showAns={true}
    />
  );
}
